/**
 * Ensure that all details elements in an HTML string are closed, except for video.
 * If details includes video, it will ensure details has an open attribute.
 *
 * @param {string} htmlStr - The HTML string to process.
 * @returns {string} The processed HTML string.
 */

export const formatDetailsHtml = (htmlStr: string): string => {
  // Find all details elements
  const detailsRegex = /<details[^>]*>(.*?)<\/details>/gs;
  return htmlStr.replace(detailsRegex, (match, content) => {
    // Check if the content contains a video element
    const containsVideo = /<video[^>]*>.*?<\/video>/is.test(content);
    // If it contains video, ensure the open attribute is present
    return match.replace(/<details[^>]*>/i, (openTag) =>
      containsVideo
        ? openTag.includes('open')
          ? openTag
          : openTag.replace('>', ' open>')
        : openTag.replace(/\sopen(?:=(?:"[^"]*"|'[^']*'|[^\s>]+))?/i, ''),
    );
  });
};
